import styled from 'styled-components';

export const EntryList = styled.ul`
    li {
        :last-of-type {
            margin-bottom: 16px;
        }

        margin-bottom: 32px;
    }
`;
